var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.75v-5.8h6.44c3.64 0 5.81 2.17 5.81 5.8H9.75zM16.19 21.95H9.75v-5.7H22c-.05 3.57-2.21 5.7-5.81 5.7zM8.25 21.95h-.44C4.17 21.95 2 19.78 2 16.14V7.76c0-3.64 2.17-5.81 5.81-5.81h.44v20z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.25v5.5H9.75v-5.5H22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid6);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-6.40d84d7ad24bdc0e7e0e22aaace9a80a.svg";
export { ForwardRef as ReactComponent };